var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatWeDoIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1733 15.9999L14.3867 19.2266L20.8267 12.7733",
    stroke: "#A8A8A8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 3.26657C15.2533 2.47991 16.76 2.47991 17.6933 3.26657L19.8 5.07991C20.2 5.42657 20.9467 5.70657 21.48 5.70657H23.7467C25.16 5.70657 26.32 6.86657 26.32 8.27991V10.5466C26.32 11.0666 26.6 11.8266 26.9467 12.2266L28.76 14.3332C29.5467 15.2532 29.5467 16.7599 28.76 17.6932L26.9467 19.7999C26.6 20.1999 26.32 20.9466 26.32 21.4799V23.7466C26.32 25.1599 25.16 26.3199 23.7467 26.3199H21.48C20.96 26.3199 20.2 26.5999 19.8 26.9466L17.6933 28.7599C16.7733 29.5466 15.2667 29.5466 14.3333 28.7599L12.2267 26.9466C11.8267 26.5999 11.08 26.3199 10.5467 26.3199H8.24001C6.82667 26.3199 5.66667 25.1599 5.66667 23.7466V21.4666C5.66667 20.9466 5.38667 20.1999 5.05334 19.7999L3.25334 17.6799C2.48001 16.7599 2.48001 15.2666 3.25334 14.3466L5.05334 12.2266C5.38667 11.8266 5.66667 11.0799 5.66667 10.5599V8.26657C5.66667 6.85324 6.82667 5.69324 8.24001 5.69324H10.5467C11.0667 5.69324 11.8267 5.41324 12.2267 5.06657L14.3333 3.26657Z",
    stroke: "#A8A8A8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatWeDoIcon03);
export default __webpack_public_path__ + "static/media/what-we-do-icon03.1effbbaf851f6e8276c2b755123db833.svg";
export { ForwardRef as ReactComponent };